import React, { useEffect,useState, forwardRef, useImperativeHandle,useRef } from "react";
import {
  Alert,
  Button,
  Slider,
  Snackbar,
  Table,
  TableBody,
} from "@mui/material";
import { useSelector } from 'react-redux';
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import MultiSelect from  'react-multiple-select-dropdown-lite'
import  'react-multiple-select-dropdown-lite/dist/index.css'
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import {
  RadioGroup,
  FormLabel,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { handlingCatchError } from "../../../Utils/ErrorHandling";
import { useNavigate } from "react-router-dom";
import {
  Nav,
  NavLink,
  NavItem,
  TabContent,
  TabPane,
  Row,
  Col,
} from "reactstrap";
import classnames from "classnames";
import { LoadingButton } from "@mui/lab";
import { useLocation } from "react-router-dom";
import ReactSelect from 'react-select';

import AdditionalLodging from '../../../Assets/Images/icons/Additional Lodging.png';
import BeachAccess from '../../../Assets/Images/icons/Beach Access.png';
import Cabins from '../../../Assets/Images/icons/Cabins.png';
import Cafe from '../../../Assets/Images/icons/Cafe.webp';
import DumpStation from '../../../Assets/Images/icons/Dump Station.png';
import ElectricHookup from '../../../Assets/Images/icons/Electric Hookup.png';
import BackIn from '../../../Assets/Images/icons/BackIn.png';
import DogParks from '../../../Assets/Images/icons/DogParks.png';
import LaundryAccess from '../../../Assets/Images/icons/LaundryAccess.png';
import PullInPullThrough from '../../../Assets/Images/icons/PullInPullThrough.png';
import SelfServiceCarWash from '../../../Assets/Images/icons/SelfServiceCarWash.png';
import FireRing from '../../../Assets/Images/icons/Fire Ring.png';
import Fishing from '../../../Assets/Images/icons/Fishing.png';
import GameRoomArcade from '../../../Assets/Images/icons/GameRoom Arcade.png';
import GolfcartRentals from '../../../Assets/Images/icons/Golfcart Rentals.png';
import Hookups from '../../../Assets/Images/icons/Hookups.png';
import Lakeside from '../../../Assets/Images/icons/Lake-side.png';
import OnsitePropane from '../../../Assets/Images/icons/Onsite Propane.png';
import PetAllowed from '../../../Assets/Images/icons/Pet Allowed.png';
import PicnicTable from '../../../Assets/Images/icons/Picnic Table.webp';
import RecHall from '../../../Assets/Images/icons/Rec Hall.webp';
import SewerHookup from '../../../Assets/Images/icons/Sewer Hookup.png';
import ShowerandBathrooms from '../../../Assets/Images/icons/Shower and Bathrooms.png';
import SiteLockers from '../../../Assets/Images/icons/Site Lockers.png';
import SportsCourts from '../../../Assets/Images/icons/Sports Courts.png';
import SwimmingPool from '../../../Assets/Images/icons/Swimming Pool.png';
import TentCamping from '../../../Assets/Images/icons/Tent Camping.png';
import VehicularAccess from '../../../Assets/Images/icons/Vehicular Access.png';
import GlampingImg from '../../../Assets/Images/icons/glamping.png';
import EVcharging from '../../../Assets/Images/icons/Vehicle Charging.png';
import WaterHookup from '../../../Assets/Images/icons/Water Hookup.png';
import Switch from '@mui/material/Switch';
import { apiCommonTrigger } from "../../../Utils/apiServicehelper";
import { Config } from "../../../Utils/Config";
import ConstantData from "../../../Utils/Constant";


export const Filter = forwardRef((props, ref) => {
  const {handleSearchPins} = props;
  const searchPinAppending = useSelector((state) => state.searchPinAppending);
  const [filterVisibility, setFilterVisibility] = React.useState(false);
  const [loc_street, setLoc_Street] = React.useState("");
  const [loc_city, setLoc_City] = React.useState("");
  const location = useLocation();
  const [stateList, setStateList] = React.useState([]);
  const [dropDownItems, setDropDownItems] = React.useState([]);
  const [radioItems, setRadioItems] = React.useState([]);
  const [textItems, setTextitems] = React.useState([]);
  const [activityItems, setActivityItems] = React.useState([]);
  const [selected, setSelected] = React.useState([]);
  const [includeAny, setIncludeAny] = React.useState(0);
  const [filters, setFilters] = React.useState(null);
  const [filterResponse, setFilterResponse] = React.useState(false);
  const [refresh, setRefresh] = React.useState(false);
  const [ErrMsgCellphoneconnectivity, setErrMsgCellphoneconnectivity] =
    React.useState("");
  const [ErrMsgAttractionsDescriptions, setErrMsgAttractionsDescriptions] =
    React.useState("");
  const [ErrMsgLocStreet, setErrMsgLocStreet] = React.useState("");
  const [ErrMsgLocCity, setErrMsgLocCity] = React.useState("");
  const [tabValue, setTabValue] = React.useState({
    active: "1",
    mapSearch: 1,
  });
  const [availableAmenities, unAvailableAmenities] = useState({});
  const [hookupFilter, setHookupFilter] = useState({});

  const [arr, setArr] = React.useState([]);
  const [spotsError, setSpotsError] = useState({ min: '', max: '' });
  const [spotsInMarket,setSpotsInMarket]=useState({min:false,max:false})
  const navigate = useNavigate();
  const filterOptions = useSelector((state) => state.filterOptions);
  const [snackBarInfo,setSnackBarInfo]=useState({
    open:false,
    vertical: 'top',
    horizontal: 'center',
    severity:"info",
    message: "No RV Parks Found"
  })
   const { vertical, horizontal ,severity,message,open } = snackBarInfo;
   const numberInputProps = {
     type: "number",
     min: 1,
     sx: {
       "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
         {
           display: "none",
         },
       "& input[type=number]": {
         MozAppearance: "textfield",
       },
     },
   };
  useEffect(() => {
    
    const handleClick = (event) => {
      const classNamedata = "map-reset-search-explorer";
      if(event.target.id === classNamedata){  setHookupFilter({}); unAvailableAmenities({}); }
    };

    // Add event listener
    document.addEventListener('click', handleClick);

    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener('click', handleClick);
    };

  }, []);
  
const handleMinMaxError = (updatedSpots,index) => {
  const { min, max } = updatedSpots;
  const globalMin = ConstantData.spotsInMarket.min;
  const globalMax = ConstantData.spotsInMarket.max;
  let errors = { min: "", max: "" };
  if (min === null) {
    errors.min = "";
  } else if (min !== false && min < globalMin) {
    errors.min = `Minimum should not be less than ${globalMin}`;
  } else if (min !== false && min > globalMax) {
    errors.min = `Minimum should not exceed ${globalMax}`;
  } else {
    if ((min || globalMin) > (max || globalMax) && index == 0) {
      errors.min = "Minimum should be less than or equal to Maximum";
    }
  }
  if (max === null) {
    errors.max = "";
  } else if (max !== false && max < globalMin) {
    errors.max = `Maximum should not be less than ${globalMin}`;
  } else if (max !== false && max > globalMax) {
    errors.max = `Maximum should not exceed ${globalMax}`;
  } else {
    if ((min || globalMin) > (max || globalMax) && index === 1) {
      errors.max = "Maximum should be greater than or equal to Minimum";
    }
  }
  setSpotsError(errors);
};
const handleChangeMarketStores =
  (index = null) =>
  (event, newValue) => {
    if (index === null) {
      const sorted = [...newValue].sort((a, b) => a - b);
      setSpotsInMarket({ min: sorted[0], max: sorted[1] });    
      setSpotsError({ min: "", max: "" });      
    } else {  
    let updatedSpots = {
     ...spotsInMarket,
     [index === 0 ? "min" : "max"]:parseInt(event.target.value)>=0?parseInt(event.target.value):null,
   };    
     handleMinMaxError(updatedSpots, index);
     setSpotsInMarket(updatedSpots);
    }    
  };

const getMinMaxValue=(value)=>{
   return `${value}°C`;
}
  const generateAmenitiesRadioItems = () => {

    const labelImages = {
      "Glamping": GlampingImg,
      'Additional Lodging': AdditionalLodging,
      'Beach Access': BeachAccess,
      "Cabins": Cabins,
      "Cafe": Cafe,
      'Dump Station': DumpStation,
      'Fire Ring': FireRing,
      "Fishing": Fishing,
      'Gameroom Arcade': GameRoomArcade,
      'Golfcart Rentals': GolfcartRentals,
      'Lake-side': Lakeside,
      'Onsite Propane': OnsitePropane,
      'Pet Allowed': PetAllowed,
      'Picnic Table': PicnicTable,
      'Rec. Hall': RecHall,
      'Shower and Bathrooms': ShowerandBathrooms,
      'Site Lockers': SiteLockers,
      'Sports Courts': SportsCourts,
      'Swimming Pool': SwimmingPool,
      'Tent Camping': TentCamping,
      'Vehicular Access': VehicularAccess,
      'Back In': BackIn,
      'Dog Parks': DogParks,
      'Laundry Access': LaundryAccess,
      'Pull In / Pull Through': PullInPullThrough,
      'Self Service Car Wash': SelfServiceCarWash,
      "EV Charging" : EVcharging
    };

    return (
      <TableBody>
        {radioItems.map((items) => {
         const label = labelImages[items.label] ? ( <img src={labelImages[items.label]} alt="icons" className="table-icons" /> ) : null;
          if(items.label !== 'Hookups' && items.label !== 'Sewer Hookup' && items.label !== 'Water Hookup' && items.label !== 'EA Twenty Amp' && items.label !== 'EB Thirty Amp' && items.label !== 'EC Fifty Amp')
          return (
            <>
              <tr>
                <td className="amenities-label">
                  <FormLabel id="demo-radio-buttons-group-label">
                    <div className="img-text">
                      <span className="img-tag">{label}</span>
                      <span className="pro-name">{items.label}</span>
                   </div>
                  </FormLabel>
                </td>



                    <td>
                      <Switch
                        checked={filters?.[items.value] === "3" ?? false}
                        id={"available-amenities"}
                        name={items.value}
                          onChange={handleChange(
                          `${items.label}`,
                          `${items.value}`
                        )}
                        className="switcher_btn"
                      />
            </td>

            <td>
                      <Switch
                        checked={filters?.[items.value] === "1" ?? false}
                        id={"unavailable-amenities"}
                        name={items.value}
                          onChange={handleChange(
                          `${items.label}`,
                          `${items.value}`
                        )}
                        className="switcher_btn"
                      />
            </td>
              </tr>
            </>
          );
        })}
      </TableBody>
    );
  };

  const generateHookupsToggleItems = () => {
    return (
      <>
        {radioItems.map((items) => {
          let label = items.label === 'Hookups' ? <img src={Hookups} alt="icons" className="table-icons"/> : items.label === 'Sewer Hookup' ? <img src={SewerHookup} alt="icons" className="table-icons"/> : items.label === 'Water Hookup' ? <img src={WaterHookup} alt="icons" className="table-icons"/> : '' ;
          if(items.label === 'Hookups' || items.label === 'Sewer Hookup' || items.label === 'Water Hookup' || items.label === 'EA Twenty Amp' || items.label === 'EB Thirty Amp' || items.label === 'EC Fifty Amp')
          return (
              <tr>
                <td className="amenities-label">
                  <FormLabel id="demo-radio-buttons-group-label">
                    <div className="img-text">
                      {items.label === 'EA Twenty Amp' || items.label === 'EB Thirty Amp' || items.label === 'EC Fifty Amp' ? '' :
                      <span className="img-tag">{label}</span>}
                      <span className={items.label === 'EA Twenty Amp' || items.label === 'EB Thirty Amp' || items.label === 'EC Fifty Amp' ? 'pro-name ul-list-item' : 'pro-name'}>{items.label === 'EA Twenty Amp' ? '20 Amp' : items.label === 'EB Thirty Amp' ? '30 Amp' : items.label === 'EC Fifty Amp' ? '50 Amp' : items.label}</span>
                   </div>
                  </FormLabel>
                </td>
                <RadioGroup
                  row
                  aria-labelledby="demo-controlled-radio-buttons-group"
                  name={items.value}
                  className="display-content"
                  // defaultValue="0"

                  defaultValue={
                    props && props.updatedFilterObj !== null && Object.keys(props.updatedFilterObj).find(key => key.toLowerCase() === (items.value).toLowerCase()) &&  props.updatedFilterObj[Object.keys(props.updatedFilterObj).find(key => key.toLowerCase() === (items.value).toLowerCase())] !== null ?  props.updatedFilterObj[Object.keys(props.updatedFilterObj).find(key => key.toLowerCase() === (items.value).toLowerCase())] :"0"
                  }
                  onChange={handleChange(`${items.label}`, `${items.value}`)}                >
                  {items.lookups.map((option) => {
                    return (
                      <td>
                      <Switch
                        checked={((filters?.[items.value]==="3" && option.label === "Yes") ||  (filters?.[items.value]==="1" && option.label === "No") )}
                        name={option.value}
                        value={option.value}
                        id="hookup-input"
                          onChange={handleChange(
                            `${option.label}`,
                            `${items.value}`,items.label
                          )}
                        className="switcher_btn"
                      />
                      </td>
                    );
                  })}
                </RadioGroup>
              </tr>
          );
        })}
      </>
    );
  };

  const generateAmenitiesLookups = () => {
    return dropDownItems.map((items) => {
      return (
        <>
          <Col md={6} className="ps-0">
            <FormControl variant="outlined" fullWidth>
              <InputLabel id="demo-simple-select-label">
                {items.label}
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                className="select-dropdown"
                label={items.label}
                onChange={handleChange(`${items.label}`, `${items.value}`)}
              
                  defaultValue={
                    props && props.updatedFilterObj !== null && Object.keys(props.updatedFilterObj).find(key => key.toLowerCase() === (items.value).toLowerCase()) &&  props.updatedFilterObj[Object.keys(props.updatedFilterObj).find(key => key.toLowerCase() === (items.value).toLowerCase())] !== null ?  props.updatedFilterObj[Object.keys(props.updatedFilterObj).find(key => key.toLowerCase() === (items.value).toLowerCase())] :""
                  }
               
              >
                <MenuItem value="">--Select--</MenuItem>
                {items.lookups && items.lookups.map((option) => {
                  return (
                    <MenuItem value={option.value}>{option.label}</MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Col>
        </>
      );
    });
  };

  const handleToggleChange = (label, name) => {

    if (hookupFilter[name] === "3" && label === "Yes") {
      setHookupFilter({ ...hookupFilter, [name]: null });
      return;
    }
  
    if (hookupFilter[name] === "1" && label === "No") {
      setHookupFilter({ ...hookupFilter, [name]: null });
      return;
    }
  
    // Update the state with new value
    setHookupFilter({ ...hookupFilter, [name]: label === "Yes" ? "3" : "1" });
  }
  

  
  const handleChange = (label, name , hookupLabel=null) => (event) => {
    let id = event.target.id;

    if(id === "available-amenities" && event.target.value === "on"){
      event.target.value = "3"
    }

    if(id === "unavailable-amenities" && event.target.value === "on"){
      event.target.value = "1"
    } 
    
    if(id === "hookup-input"){
      handleToggleChange(label, name);
      if(hookupLabel)  label = hookupLabel
    }

    // setFilterResponse(false);
    let value = "";
    let ovalue = event.target.value;

    const checked = event.target.checked;

    if(id === "available-amenities"){
      unAvailableAmenities(pervArr=> {
        return { ...pervArr, [name]: checked ? "3" : null }
      })
    } 

    if(id === "unavailable-amenities"){
      unAvailableAmenities(pervArr=> {
        return { ...pervArr, [name]: checked ? "1" : null }
      })
    } 
    
    

    if (filters !== null) {
      // when user try to update the existing property in filter obj
      // since we are sending props.updatedFilterObj, you will get every property
      if (Object.keys(filters).find(item => item.toLowerCase() === name.toLowerCase())) {
    // let key = Object.keys(filters).find(item => item.toLowerCase() === name.toLowerCase());
          if( filters[Object.keys(filters).find(item => item.toLowerCase() === name.toLowerCase())] !== event.target.value){
            // updating the value of the property if user changed the value of same prop
            filters[Object.keys(filters).find(item => item.toLowerCase() === name.toLowerCase())] = event.target.value === 'hasOwner' || event.target.value === 'hasManagement' ? event.target.checked : event.target.value === "0" ? null : event.target.value;
          }   
       
      }
      else {
        setFilters({
          ...filters,
          [name.toLowerCase()]:
            event.target.value === "" || event.target.value  === "0"
              ? null
              : event.target.value === "hasOwner" ||
                event.target.value === "hasManagement"
              ? true
              : event.target.value,
        });
      }

    }
    else if (filters === null) {
      setFilters({
        ...filters,
        [name.toLowerCase()]:
          event.target.value === ""
            ? null
            : event.target.value === "hasOwner" ||
              event.target.value === "hasManagement"
            ? true
            : event.target.value,
      });
    }
    
       if (ovalue) {
      const lowerName = name.toLowerCase();

      if (lowerName !== "stateId") {
        value = (ovalue !== '0') ? ovalue : null;
      }

      // push actual value to arr for txtitems
      if (name.toLowerCase() === "street") {
        value = event.target.value;
      }
      if (name.toLowerCase() === "city") {
        value = event.target.value;
      }
      if (name.toLowerCase() === "cellphoneconnectivity".toLowerCase()) {
        value = event.target.value;
      }
      if (name.toLowerCase() === "attractionsDescriptions".toLowerCase()) {
        value = event.target.value;
      }
      // converting val to int & checks its a numeber r NaN
      if (isNaN(ovalue)) {
        value = ovalue;
      }
      // for state
      if (name.toLowerCase() === "stateId".toLowerCase()) {
        value = ovalue;
      }

      if (name.toLowerCase() === "hasOwner".toLowerCase()) {
        value = event.target.checked ? "Yes" : "";
      }
      if (name.toLowerCase() === "hasManagement".toLowerCase()) {
        value = event.target.checked ? "Yes" : "";
      }
    }

    let index = null , existingValue =null ;
    if(arr.length){
      index = arr.findIndex(item => item.name === name);
      if(arr[index]) existingValue = arr[index].value;
    }

    if (arr.length === 0 && value !== null) {
      arr.push({ label, name, value });
    } else {
      const index = arr.findIndex(x => x.name.toLowerCase() === name.toLowerCase());
   if (index !== -1) {
  if (value) {
    if (arr[index].value !== value) {
      arr[index].value = value;
      if(arr[index].name==="hasmanagement"){ //getting keyname hasmanagement from api
        arr[index].name="hasManagement"
      }
    }
  } else {
    arr.splice(index, 1); // remove the item if value is falsy (null, "", 0, etc.)
  }
} else {
        arr.push({ label, name, value });
      }
    }

    if(ovalue && index != null && existingValue === ovalue){
      arr.splice(index, 1);
    }

    if (name === "cellphoneconnectivity") {
      let value = event.target.value;
      setCellphoneconnectivity(value);
      if (value.length >= 1) {
        setErrMsgCellphoneconnectivity("Please enter at least two characters");
      }
      if (value.length === 0) {
        setErrMsgCellphoneconnectivity("");
      } else if (value.length >= 2) {
        setErrMsgCellphoneconnectivity("");
      }
    }
    if (name?.toLowerCase() === "attractionsDescriptions".toLowerCase()) {
      let value = event.target.value;
      setFilters(pre=>({...(pre||{}) , [name]:event.target.value}))
      if (value.length >= 1) {
        setErrMsgAttractionsDescriptions(
          "Please enter at least two characters"
        );
      }
      if (value.length === 0) {
        setErrMsgAttractionsDescriptions("");
      } else if (value.length >= 2) {
        setErrMsgAttractionsDescriptions("");
      }
    }
    if (name === "street") {
      let value = event.target.value;
      setLoc_Street(event.target.value);
      if (value.length >= 1) {
        setErrMsgLocStreet("Please enter at least two characters");
      }
      if (value.length === 0) {
        setErrMsgLocStreet("");
      } else if (value.length >= 2) {
        setErrMsgLocStreet("");
      }
    }
    if (name === "city") {
      let value = event.target.value;
      setLoc_City(event.target.value);
      if (value.length >= 1) {
        setErrMsgLocCity("Please enter at least two characters");
      }
      if (value.length === 0) {
        setErrMsgLocCity("");
      } else if (value.length >= 2) {
        setErrMsgLocCity("");
      }
    }
  };
  // // called from parent components
  useImperativeHandle(ref, () => ({
    callOnSubmit(value, isRadius , bool = false) {
      onSubmit("2", value, isRadius , bool);
    },
    callOnSubmitdata(value) {
      onSubmit(value);
    },
    resetFil(val) {     
      resetFilter(val);
      // setFilterResponse(false);      
      setArr([]);
    },
    openFilter(arg) {
      setFilterVisibility(arg);
    },
    preFillArr(arr) {
      setArr(arr);
    },
    setActivityUp(arr){
      setSelected(arr)
    },
    setSpotsListInMarket(minMaxValue){     
      setSpotsInMarket(minMaxValue)
      setSpotsError({min:"",max:""})
    },
    setOperator(val){
      setIncludeAny(val)
    },
    setEmptyParksResponse(response){   
      setSnackBarInfo((pre)=>({...pre,open:response}))
      setFilterResponse(response)
    }
  }));

  const resetFilter = (val) => {

    if(val){
      const keysWithNullValues = Object.keys(val).filter(key => val[key] === null);
    
      // Create copies of the current states to avoid direct mutation
      const updatedAmenities = { ...availableAmenities };
      const updatedHookupFilter = { ...hookupFilter };
    
      // Iterate over keys with null values and delete them from both updated objects
      keysWithNullValues.forEach(key => {
        delete updatedAmenities[key];
        delete updatedHookupFilter[key];
      });
    
      // Update states
      unAvailableAmenities(updatedAmenities);
      setHookupFilter(updatedHookupFilter);
    }  
    // Update the filters
    setFilters(val);
  };

  // passing id to  avoid filter to open based on above call
  const onSubmit = (id, radiusValue, isRadius , bool = false) => {
  
    const lat = props.latitude ? props.latitude : null;
    const long = props.longitude ? props.longitude : null;

    let isShowCircle = lat === null && long === null ? false : true;

    if (
      !isShowCircle &&
      filters &&
      filters !== null &&
      Object.values(filters).every((x) => x === null || x === "" || x === "0")
    ) {
      //  x.match(/^ *$/) !== null checks for whiteSpace

      setFilters(null);
      setArr([]);

      return false;
    }
    // if errMsg exists don't hit API
    if (
      ErrMsgAttractionsDescriptions !== "" ||
      ErrMsgCellphoneconnectivity !== "" ||
      ErrMsgLocCity !== "" ||
      ErrMsgLocStreet !== ""
    ) {
      return false;
    } else {
      setRefresh(true);
      let radius =
        (isRadius === "1" && radiusValue) || props.showCircle
          ? radiusValue
          : null;
      let Hookups =
        filters !== null && Object.keys(filters).find(item => item.toLowerCase() === 'hookups'.toLowerCase())
          && filters[Object.keys(filters).find(item => item.toLowerCase() === 'hookups'.toLowerCase())] !== '0' ?
          filters[Object.keys(filters).find(item => item.toLowerCase() === 'hookups'.toLowerCase())]
          : null;
         
      let keyword = null;
      let street =
      filters !== null && Object.keys(filters).find(item => item.toLowerCase() === 'street'.toLowerCase())
      && filters[Object.keys(filters).find(item => item.toLowerCase() === 'street'.toLowerCase())] !== '' ?
      filters[Object.keys(filters).find(item => item.toLowerCase() === 'street'.toLowerCase())]
      : null;
      let city =
      filters !== null && Object.keys(filters).find(item => item.toLowerCase() === 'city'.toLowerCase())
      && filters[Object.keys(filters).find(item => item.toLowerCase() === 'city'.toLowerCase())] !== '' ?
      filters[Object.keys(filters).find(item => item.toLowerCase() === 'city'.toLowerCase())]
      : null;

      let hasOwner =
      filters !== null && Object.keys(filters).find(item => item.toLowerCase() === 'hasOwner'.toLowerCase()) ?
      filters[Object.keys(filters).find(item => item.toLowerCase() === 'hasOwner'.toLowerCase())]
      : null;
      let hasManagement =
      filters !== null && Object.keys(filters).find(item => item.toLowerCase() === 'hasManagement'.toLowerCase()) ?
      filters[Object.keys(filters).find(item => item.toLowerCase() === 'hasManagement'.toLowerCase())]
      : null;

      let stateId =  filters !== null && Object.keys(filters).find(item => item.toLowerCase() === 'stateId'.toLowerCase())
      && filters[Object.keys(filters).find(item => item.toLowerCase() === 'stateId'.toLowerCase())] !== '' ?
      filters[Object.keys(filters).find(item => item.toLowerCase() === 'stateId'.toLowerCase())]
      : null;
      let lat = props.latitude ? props.latitude : null;
      let long = props.longitude ? props.longitude : null;
      let ShowersAndBathrooms =
      filters !== null && Object.keys(filters).find(item => item.toLowerCase() === 'showersAndBathrooms'.toLowerCase())
      && filters[Object.keys(filters).find(item => item.toLowerCase() === 'showersAndBathrooms'.toLowerCase())] !== '0' ?
      filters[Object.keys(filters).find(item => item.toLowerCase() === 'showersAndBathrooms'.toLowerCase())]
      : null;
      let DumpStation =
      filters !== null && Object.keys(filters).find(item => item.toLowerCase() === 'dumpStation'.toLowerCase())
      && filters[Object.keys(filters).find(item => item.toLowerCase() === 'dumpStation'.toLowerCase())] !== '0' ?
      filters[Object.keys(filters).find(item => item.toLowerCase() === 'dumpStation'.toLowerCase())]
      : null;
      let OnSitePropane =
      filters !== null && Object.keys(filters).find(item => item.toLowerCase() === 'onSitePropane'.toLowerCase())
      && filters[Object.keys(filters).find(item => item.toLowerCase() === 'onSitePropane'.toLowerCase())] !== '0' ?
      filters[Object.keys(filters).find(item => item.toLowerCase() === 'onSitePropane'.toLowerCase())]
      : null;
      let TentCamping =
      filters !== null && Object.keys(filters).find(item => item.toLowerCase() === 'tentCamping'.toLowerCase())
      && filters[Object.keys(filters).find(item => item.toLowerCase() === 'tentCamping'.toLowerCase())] !== '0' ?
      filters[Object.keys(filters).find(item => item.toLowerCase() === 'tentCamping'.toLowerCase())]
      : null;
      let SiteLockers =
      filters !== null && Object.keys(filters).find(item => item.toLowerCase() === 'siteLockers'.toLowerCase())
      && filters[Object.keys(filters).find(item => item.toLowerCase() === 'siteLockers'.toLowerCase())] !== '0' ?
      filters[Object.keys(filters).find(item => item.toLowerCase() === 'siteLockers'.toLowerCase())]
      : null;
      let InternetConnectivity =
      filters !== null && Object.keys(filters).find(item => item.toLowerCase() === 'internetConnectivity'.toLowerCase())
      && filters[Object.keys(filters).find(item => item.toLowerCase() === 'internetConnectivity'.toLowerCase())] !== '' ?
      filters[Object.keys(filters).find(item => item.toLowerCase() === 'internetConnectivity'.toLowerCase())]
      : null;
      let InternetConnectivityPayment =
      filters !== null && Object.keys(filters).find(item => item.toLowerCase() === 'internetConnectivityPayment'.toLowerCase())
      && filters[Object.keys(filters).find(item => item.toLowerCase() === 'internetConnectivityPayment'.toLowerCase())] !== '' ?
      filters[Object.keys(filters).find(item => item.toLowerCase() === 'internetConnectivityPayment'.toLowerCase())]
      : null;
      let Cellphoneconnectivity =
      filters !== null && Object.keys(filters).find(item => item.toLowerCase() === 'cellphoneconnectivity'.toLowerCase())
      ? filters[Object.keys(filters).find(item => item.toLowerCase() === 'cellphoneconnectivity'.toLowerCase())]
      : null;
      let Cafe =
      filters !== null && Object.keys(filters).find(item => item.toLowerCase() === 'cafe'.toLowerCase())
      && filters[Object.keys(filters).find(item => item.toLowerCase() === 'cafe'.toLowerCase())] !== '0' ?
      filters[Object.keys(filters).find(item => item.toLowerCase() === 'cafe'.toLowerCase())]
      : null;
      let Cabins =
      filters !== null && Object.keys(filters).find(item => item.toLowerCase() === 'cabins'.toLowerCase())
      && filters[Object.keys(filters).find(item => item.toLowerCase() === 'cabins'.toLowerCase())] !== '0' ?
      filters[Object.keys(filters).find(item => item.toLowerCase() === 'cabins'.toLowerCase())]
      : null;
      let GameRoomArcade =
      filters !== null && Object.keys(filters).find(item => item.toLowerCase() === 'gameRoomArcade'.toLowerCase())
      && filters[Object.keys(filters).find(item => item.toLowerCase() === 'gameRoomArcade'.toLowerCase())] !== '0' ?
      filters[Object.keys(filters).find(item => item.toLowerCase() === 'gameRoomArcade'.toLowerCase())]
      : null;
      let RecHall =
      filters !== null && Object.keys(filters).find(item => item.toLowerCase() === 'recHall'.toLowerCase())
      && filters[Object.keys(filters).find(item => item.toLowerCase() === 'recHall'.toLowerCase())] !== '0' ?
      filters[Object.keys(filters).find(item => item.toLowerCase() === 'recHall'.toLowerCase())]
      : null;
      let SportsCourts =
      filters !== null && Object.keys(filters).find(item => item.toLowerCase() === 'sportsCourts'.toLowerCase())
      && filters[Object.keys(filters).find(item => item.toLowerCase() === 'sportsCourts'.toLowerCase())] !== '0' ?
      filters[Object.keys(filters).find(item => item.toLowerCase() === 'sportsCourts'.toLowerCase())]
      : null;
      let Petallowed =
      filters !== null && Object.keys(filters).find(item => item.toLowerCase() === 'petallowed'.toLowerCase())
      && filters[Object.keys(filters).find(item => item.toLowerCase() === 'petallowed'.toLowerCase())] !== '0' ?
      filters[Object.keys(filters).find(item => item.toLowerCase() === 'petallowed'.toLowerCase())]
      : null;
      let Fishing =
      filters !== null && Object.keys(filters).find(item => item.toLowerCase() === 'fishing'.toLowerCase())
      && filters[Object.keys(filters).find(item => item.toLowerCase() === 'fishing'.toLowerCase())] !== '0' ?
      filters[Object.keys(filters).find(item => item.toLowerCase() === 'fishing'.toLowerCase())]
      : null;
      let GolfCartRentals =
      filters !== null && Object.keys(filters).find(item => item.toLowerCase() === 'golfCartRentals'.toLowerCase())
      && filters[Object.keys(filters).find(item => item.toLowerCase() === 'golfCartRentals'.toLowerCase())] !== '0' ?
      filters[Object.keys(filters).find(item => item.toLowerCase() === 'golfCartRentals'.toLowerCase())]
      : null;
      let Swimmingpool =
      filters !== null && Object.keys(filters).find(item => item.toLowerCase() === 'swimmingpool'.toLowerCase())
      && filters[Object.keys(filters).find(item => item.toLowerCase() === 'swimmingpool'.toLowerCase())] !== '0' ?
      filters[Object.keys(filters).find(item => item.toLowerCase() === 'swimmingpool'.toLowerCase())]
      : null;
      let Lakeside =
      filters !== null && Object.keys(filters).find(item => item.toLowerCase() === 'lakeside'.toLowerCase())
      && filters[Object.keys(filters).find(item => item.toLowerCase() === 'lakeside'.toLowerCase())] !== '0' ?
      filters[Object.keys(filters).find(item => item.toLowerCase() === 'lakeside'.toLowerCase())]
      : null;
      let BeachAccess =
      filters !== null && Object.keys(filters).find(item => item.toLowerCase() === 'beachAccess'.toLowerCase())
      && filters[Object.keys(filters).find(item => item.toLowerCase() === 'beachAccess'.toLowerCase())] !== '0' ?
      filters[Object.keys(filters).find(item => item.toLowerCase() === 'beachAccess'.toLowerCase())]
      : null;
      let AttractionsDescriptions =
      filters !== null && Object.keys(filters).find(item => item.toLowerCase() === 'attractionsDescriptions'.toLowerCase())
      ? filters[Object.keys(filters).find(item => item.toLowerCase() === 'attractionsDescriptions'.toLowerCase())]  
      : null;

      let PicnicTable = 
      filters !== null && Object.keys(filters).find(item => item.toLowerCase() === 'picnictable'.toLowerCase())
      ? filters[Object.keys(filters).find(item => item.toLowerCase() === 'picnictable'.toLowerCase())]  
      : null;
      
      let FireRing =
      filters !== null && Object.keys(filters).find(item => item.toLowerCase() === 'firering'.toLowerCase())
      ? filters[Object.keys(filters).find(item => item.toLowerCase() === 'firering'.toLowerCase())]  
      : null;
      
      let VehicularAccess = 
      filters !== null && Object.keys(filters).find(item => item.toLowerCase() === 'vehicularaccess'.toLowerCase())
      ? filters[Object.keys(filters).find(item => item.toLowerCase() === 'vehicularaccess'.toLowerCase())]  
      : null;
      
      let EATwentyAmp =
      filters !== null && Object.keys(filters).find(item => item.toLowerCase() === 'eatwentyamp'.toLowerCase())
      ? filters[Object.keys(filters).find(item => item.toLowerCase() === 'eatwentyamp'.toLowerCase())]  
      : null;

      let EBThirtyAmp =
      filters !== null && Object.keys(filters).find(item => item.toLowerCase() === 'ebthirtyamp'.toLowerCase())
      ? filters[Object.keys(filters).find(item => item.toLowerCase() === 'ebthirtyamp'.toLowerCase())]  
      : null;

      let ECFiftyAmp =
      filters !== null && Object.keys(filters).find(item => item.toLowerCase() === 'ecfiftyamp'.toLowerCase())
      ? filters[Object.keys(filters).find(item => item.toLowerCase() === 'ecfiftyamp'.toLowerCase())]  
      : null;
      
      let WaterHookup = 
      filters !== null && Object.keys(filters).find(item => item.toLowerCase() === 'waterhookup'.toLowerCase())
      ? filters[Object.keys(filters).find(item => item.toLowerCase() === 'waterhookup'.toLowerCase())]  
      : null; 

      let SelfServiceCarWash = 
      filters !== null && Object.keys(filters).find(item => item.toLowerCase() === 'selfservicecarwash'.toLowerCase())
      ? filters[Object.keys(filters).find(item => item.toLowerCase() === 'selfservicecarwash'.toLowerCase())]  
      : null; 

      let PullInPullThrough = 
      filters !== null && Object.keys(filters).find(item => item.toLowerCase() === 'pullinpullthrough'.toLowerCase())
      ? filters[Object.keys(filters).find(item => item.toLowerCase() === 'pullinpullthrough'.toLowerCase())]  
      : null; 

      let LaundryAccess = 
      filters !== null && Object.keys(filters).find(item => item.toLowerCase() === 'laundryaccess'.toLowerCase())
      ? filters[Object.keys(filters).find(item => item.toLowerCase() === 'laundryaccess'.toLowerCase())]  
      : null; 

      let DogParks = 
      filters !== null && Object.keys(filters).find(item => item.toLowerCase() === 'dogparks'.toLowerCase())
      ? filters[Object.keys(filters).find(item => item.toLowerCase() === 'dogparks'.toLowerCase())]  
      : null; 

      let BackIn = 
      filters !== null && Object.keys(filters).find(item => item.toLowerCase() === 'backin'.toLowerCase())
      ? filters[Object.keys(filters).find(item => item.toLowerCase() === 'backin'.toLowerCase())]  
      : null; 
      
      let SewerHookup =
      filters !== null && Object.keys(filters).find(item => item.toLowerCase() === 'sewerhookup'.toLowerCase())
      ? filters[Object.keys(filters).find(item => item.toLowerCase() === 'sewerhookup'.toLowerCase())]  
      : null;
      
      
      let AdditionalLodging =
      filters !== null && Object.keys(filters).find(item => item.toLowerCase() === 'additionallodging'.toLowerCase())
      ? filters[Object.keys(filters).find(item => item.toLowerCase() === 'additionallodging'.toLowerCase())]  
      : null;
        let ElectricVehicleCharging = 
      filters !== null && Object.keys(filters).find(item => item.toLowerCase() === 'electriclevehiclecharging'.toLowerCase())
      ? filters[Object.keys(filters).find(item => item.toLowerCase() === 'electriclevehiclecharging'.toLowerCase())]  
      : null;
      let Glamping = 
      filters !== null && Object.keys(filters).find(item => item.toLowerCase() === 'glamping'.toLowerCase())
      ? filters[Object.keys(filters).find(item => item.toLowerCase() === 'glamping'.toLowerCase())]  
      : null;
      let Activities = selected.length > 0 ? selected.toString() : null;
      let IncludeAny = parseInt(includeAny) === 1 ? true : false;
      const radioId = filterOptions?.filterOptionsData.showby;
      const ops = filterOptions?.filterOptionsData.filterBy.filter(item => item.typeid === 1 && item.isactive).map(item => item.id);
      const koa = filterOptions?.filterOptionsData.filterBy.filter(item => item.typeid === 2 && item.isactive).map(item => item.id);
      const glamping = filterOptions?.filterOptionsData.filterBy.filter(item => item.typeid === 3 && item.isactive).map(item => item.id);
      var userDetails = localStorage.getItem('user') !== null ? localStorage.getItem('user') : null;  
      const user = JSON.parse(userDetails || "{}");
      const isFreeUser = (user.usertype || "") === "Free";
      let requestObject = {
        "additionallodging": AdditionalLodging ,
        "attractionsdescriptions":AttractionsDescriptions ,
        "backin": BackIn,
        "beachaccess": BeachAccess,
        "cafe": Cafe,
        "cabins": Cabins,
        "cellphoneconnectivity": Cellphoneconnectivity,
        "dogparks": DogParks,
        "dumpstation": DumpStation,
        "eatwentyamp": EATwentyAmp,
        "ebthirtyamp": EBThirtyAmp,
        "ecfiftyamp": ECFiftyAmp,
        "firering": FireRing,
        "fishing": Fishing,
        "gameroomarcade": GameRoomArcade ,
        "golfcartrentals": GolfCartRentals,
        "hookups": Hookups,
        "internetconnectivity": InternetConnectivity ,
        "internetconnectivitypayment": InternetConnectivityPayment,
        "lakeside": Lakeside,
        "laundryaccess": LaundryAccess,
        "onsitepropane": OnSitePropane,
        "petallowed": Petallowed,
        "picnictable": null,
        "pullinpullthrough": PullInPullThrough,
        "rechall":RecHall ,
        "selfservicecarwash":SelfServiceCarWash ,
        "sewerhookup": SewerHookup,
        "showersandbathrooms": ShowersAndBathrooms,
        "sitelockers": SiteLockers,
        "sportscourts": SportsCourts,
        "swimmingpool": Swimmingpool ,
        "tentcamping": TentCamping,
        "vehicularaccess": VehicularAccess,
        "waterhookup": WaterHookup,
        "searchid": 0,
        "searchname": null,
        "keyword": keyword,
        "street": street,
        "city": city,
        "stateid": stateId,
        "lat": lat,
        "longi": long,
        "radius": radius,
        "hasowner": hasOwner,
        "hasmanagement": hasManagement,
        "activities": Activities,
        "includeany": IncludeAny, 
        "koafilters": koa.join(","),
        "sizefilters": ops.join(","),
        "radioid": parseInt(radioId),
        "glampingfilters": glamping.join(","),
        'electriclevehiclecharging':ElectricVehicleCharging,
        "glamping": Glamping,
        "minspots":(!spotsInMarket.min&&spotsInMarket.max)?1:(spotsInMarket.min||1),
        "maxspots":spotsInMarket.max===false?null:spotsInMarket.max,
        "isedit" : location?.state?.isFrom === "my-market"? true : false
      }
      if(Object.keys(availableAmenities).length){
        requestObject = {...requestObject, ...availableAmenities}
      }

      if(Object.keys(hookupFilter).length){
        requestObject = {...requestObject, ...hookupFilter}
      }
    
        apiCommonTrigger("post",`${Config.API_URL}/search`,requestObject).then((res) => {
        setRefresh(false);
        if (res.data.rvParks === null||res.data.rvparks?.every((data)=>data?.data?.features?.length===0 && !isFreeUser)) {
          setSnackBarInfo((pre)=>({...pre,open:true}))
          setFilterResponse(true);
          const storeList={min:res.data.criteria?.minspots||false,max:res.data.criteria?.maxspots||false};
          setSpotsInMarket(storeList)
          checkEnablePins()
          // rendering  map acc to result
          props.setFilteredParksData([]);
          props.passValue({ data: res.data, criteria: arr.length > 0 ? arr : [], Activites:selected.length > 0 ? activityItems : [], includeValue: IncludeAny === false ? 0 : 1,spotsInMarket:storeList }, true);
          // setFilterVisibility(!filterVisibility);
          return;
        }         
        if(!bool) setSnackBarInfo((pre)=>({...pre,open:false}))
        setFilterResponse(false);
        if (id && id !== "2") {
          setFilterVisibility(!filterVisibility);
        }
        if (res.status === 200) {
          const storeList={min:spotsInMarket.min||false,max:spotsInMarket.max||false};
          setSpotsInMarket(storeList);
          props.setFilteredParksData([]);
          props.passValue({ data: res.data, criteria: arr.length > 0 ? arr : [], Activites:selected.length > 0 ? activityItems : [], includeValue: IncludeAny === false ? 0 : 1,spotsInMarket:storeList }, true);      
          checkEnablePins(true)
        } else if (res.status === 401) {
          handlingCatchError(res, navigate);
        } 
      })


      .catch(err => {
        handlingCatchError(err, navigate);
      });
    }
  };
  const isStoresInMarketSameAsInitial=()=>{  
    return (spotsInMarket.min === false && spotsInMarket.max === false) ||(spotsInMarket.min === null&& spotsInMarket.max === null ) ? true : false
  }
  const checkEnablePins = (hasPins) => {
    const activityList = selected.length > 0 ? activityItems : [];
    const appliedFiler = arr.length > 0 ? arr : [];
    const isFilterEmpty = !appliedFiler || appliedFiler.length === 0;
    const isActivitiesEmpty = !activityList || activityList.length === 0;
    const lat = props.latitude ? props.latitude : null;
    const long = props.longitude ? props.longitude : null;
    const MinMaxExpty = isStoresInMarketSameAsInitial() ? true :false;
    if(hasPins) {
      handleSearchPins();
    } else if (!(lat && long) && (!isActivitiesEmpty || !isFilterEmpty || !MinMaxExpty)) {
      handleSearchPins();
    }else if (lat && long && isActivitiesEmpty && isFilterEmpty && MinMaxExpty){
      handleSearchPins("directCall");
    }
  };


  //handle change for tab selection
  const handleTabChange = (tab) => {
    if (tabValue.active !== tab) {
      if (tab === "1") setTabValue({ active: tab, mapSearch: 1 });
      else setTabValue({ ...tabValue, active: tab });
    }
  };

  // //check isfrom path
  // useMemo(() => {
  //   if (disp === "my-market") {
  //     setTabValue({ ...tabValue, active: "2" });
  //   } else {
  //     setTabValue({ active: "1", mapSearch: 1 });
  //   }
  // }, [disp]);
  const loadLookups = () => {
    setRefresh(true);
    apiCommonTrigger("get" , Config.API_URL + "/search/filters")
    .then((res) => {
      setRefresh(false);
      if (res.status === 200) {
        let sortedRadioItems = res.data.radioitems.sort((a, b) => {
          let temp1 = a.label.toLowerCase(),
            temp2 = b.label.toLowerCase();

          if (temp1 < temp2) {
            return -1;
          }
          if (temp1 > temp2) {
            return 1;
          }
          return 0;
        });

        setRadioItems(sortedRadioItems);
        setDropDownItems(res.data.dropdownitems);
        setTextitems(res.data.textitems);
        setActivityItems(res.data.listitems);
      } else{
        handlingCatchError(res, navigate);
      }
    })
    .catch(err => {
      handlingCatchError(err, navigate);
    })
  };

  const loadStateLookup = () => {
    apiCommonTrigger("get" , Config.API_URL + "/lookup/states")
    .then((res) => {
      if (res.status === 200) {
        setStateList(res.data);
      }
      else{
        handlingCatchError(res, navigate);
      }
    
    })
    .catch(err => {
      handlingCatchError(err, navigate);
    })
  };



 

  useEffect(() => {
    loadLookups();
    loadStateLookup();
  }, []);

  const toggleFilter = () => {
    setFilterVisibility(!filterVisibility);
    // sets loc tab default when filter toggles
    setTabValue({ active: "1", mapSearch: 1 });
  };

  const handleCancel = () => {
    setFilterVisibility(!filterVisibility);
  };
  const handleEnter = (event) => {
    if (event.keyCode == 13) {
      onSubmit('1');
    }
  }
  const handleChangeMultiSelect = (selected) => {    
   setSelected(selected?.map(item => item.value) || []) 
  };
  let temp = 'listItems';
  const activityData = activityItems[temp];
  const fields = { text: 'label', value: 'value' };
  return (
    <div className="filter-section">
      <Snackbar anchorOrigin={{ vertical, horizontal }} open={open}
       autoHideDuration={5000}      
       onClose={(_, reason) => {
        if (reason === 'clickaway') {
          return;
        }
        setSnackBarInfo((prev) => ({ ...prev, open: false }));
      }}>
        <Alert
          severity={severity}
          variant="filled"
          onClose={() => {
           setSnackBarInfo((pre)=>({...pre,open:false}))
          }}
        >
          {message}
        </Alert>
      </Snackbar>
      {refresh ? (
        <div className="loader-wrap">
          <div className="loading"></div>
        </div>
      ) : null}
      <Button disabled={props?.disableFilter} onClick={() => toggleFilter()} className={props?.disableFilter? "filter-icon-btn opacity-dull" :"filter-icon-btn"}>
        <FilterAltIcon />
      </Button>
      {/* { Object.keys(appliedFiler).length !== 0 ? } */}
      {filterVisibility ? (
        <div className="filter-expand">
          <Nav tabs clasName="market-tabls">
            <NavItem>
              <NavLink
                className={classnames({ active: tabValue.active === "1" })}
                onClick={() => {
                  handleTabChange("1");
                }}
              >
                Location
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: tabValue.active === "2" })}
                onClick={() => {
                  handleTabChange("2");
                }}
              >
                Amenities and Features
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: tabValue.active === "3" })}
                onClick={() => {
                  handleTabChange("3");
                }}
              >
                Ownership and Management
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: tabValue.active === "4" })}
                onClick={() => {
                  handleTabChange("4");
                }}
              >
                Hookups
              </NavLink>
            </NavItem>
              <NavItem>
              <NavLink
                className={classnames({ active: tabValue.active === "6" })}
                onClick={() => {
                  handleTabChange("6");
                }}
              >
               Stores in market
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: tabValue.active === "5" })}
                onClick={() => {
                  handleTabChange("5");
                }}
              >
                Activities/Attractions
              </NavLink>
            </NavItem>
            
          </Nav>
          <TabContent activeTab={tabValue.active}>
            <TabPane tabId="1">
              <Row>
                <Col md={4} className="street-col">
                  <TextField
                    id="outlined-basic"
                    label="Street"
                    variant="outlined"
                    name="street"
                    // value={loc_street}
                    defaultValue={
                      props && props.updatedFilterObj !== null && Object.keys(props.updatedFilterObj).find(key => key.toLowerCase() === 'street') &&  props.updatedFilterObj[Object.keys(props.updatedFilterObj).find(key => key.toLowerCase() === "street")] !== null ?  props.updatedFilterObj[Object.keys(props.updatedFilterObj).find(key => key.toLowerCase() === "street")] :""
                    }
                    onChange={handleChange("RV Park's Street", "street")}
                    onKeyDown={handleEnter}
                  />
                  {ErrMsgLocStreet !== "" ? (
                    <p className="error-msg text-field-error">
                      {ErrMsgLocStreet && ErrMsgLocStreet}
                    </p>
                  ) : (
                    ""
                  )}
                </Col>
                <Col md={4} className="city-col">
                  <TextField
                    id="outlined-basic"
                    label="City"
                    variant="outlined"
                    name="city"
                    // value={loc_city}
                    defaultValue={
                      props && props.updatedFilterObj !== null && Object.keys(props.updatedFilterObj).find(key => key.toLowerCase() === "city") &&  props.updatedFilterObj[Object.keys(props.updatedFilterObj).find(key => key.toLowerCase() === "city")] !== null ?  props.updatedFilterObj[Object.keys(props.updatedFilterObj).find(key => key.toLowerCase() === "city")] :""
                    }
                    onChange={handleChange("RV Park's City", "city")}
                    onKeyDown={handleEnter}
                  />
                  {ErrMsgLocCity !== "" ? (
                    <p className="error-msg text-field-error">
                      {ErrMsgLocCity && ErrMsgLocCity}
                    </p>
                  ) : (
                    ""
                  )}
                </Col>
                <Col md={4} className="state-col">
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">State</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      // value={age}
                      className="select-dropdown"
                      label="State"
                      defaultValue={
                        props && props.updatedFilterObj !== null && Object.keys(props.updatedFilterObj).find(key => key.toLowerCase() === "stateid") &&  props.updatedFilterObj[Object.keys(props.updatedFilterObj).find(key => key.toLowerCase() === "stateid")] !== null ?  props.updatedFilterObj[Object.keys(props.updatedFilterObj).find(key => key.toLowerCase() === "stateid")] :""
                      }
                      onChange={handleChange("RV Park's State", "stateId")}
                    >
                      <MenuItem value="">--Select--</MenuItem>
                      {stateList.map((option) => {
                        return (
                          <MenuItem value={option.value}>
                            {option.label}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </Col>
              </Row>

              {/* <div className="amenities-btns">
                <Button
                  variant="outlined"
                  onClick={() => handleCancel()}
                  className="cancel-btn"
                >
                  Cancel
                </Button>
               
                <Button
                  variant="outlined"
                  // passing filter type & data
                  onClick={() => onSubmit("1")}
                  className="submit-btn"
                  disabled={filters === null ? true : false}
                >
                  Submit
                </Button>
                <div className="clear"></div>
              </div> */}
            </TabPane>
            <TabPane tabId="2">
              <div className="amenities-scroll amenities_features">
                <Table className="amenities-table">
                  <thead>
                    <tr>
                      <th className="amenities-label"></th>
                      <th>Available</th>
                      <th>Not Available</th>
                    </tr>
                  </thead>

                  {generateAmenitiesRadioItems()}
                </Table>

                <div className="other-amenities">
                  <h5>Other Amenities</h5>
                  <FormControl
                    sx={{ width: "100%" }}
                    className="drop-down-select"
                  >
                    <Row className="m-0">{generateAmenitiesLookups()}</Row>
                  </FormControl>
                  <Row className="m-0">
                    <Col md={6} className="ps-0 other-text-field">
                      <TextField
                        id="outlined-basic"
                        label="Cellphone Connectivity"
                        name="Cellphoneconnectivity"
                        variant="outlined"
                        cellphoneconnectivity
                        defaultValue={
                          props && props.updatedFilterObj !== null && Object.keys(props.updatedFilterObj).find(key => key.toLowerCase() === "cellphoneconnectivity") &&  props.updatedFilterObj[Object.keys(props.updatedFilterObj).find(key => key.toLowerCase() === "cellphoneconnectivity")] !== null ?  props.updatedFilterObj[Object.keys(props.updatedFilterObj).find(key => key.toLowerCase() === "cellphoneconnectivity")] :""
                        }
                        onChange={handleChange(
                          "Cellphone Connectivity",
                          "cellphoneconnectivity"
                        )}
                        onKeyDown={handleEnter}
                        fullWidth
                      />
                      {ErrMsgCellphoneconnectivity !== "" ? (
                        <p className="error-msg text-field-error">
                          {ErrMsgCellphoneconnectivity &&
                            ErrMsgCellphoneconnectivity}
                        </p>
                      ) : (
                        ""
                      )}
                    </Col>
                    <Col md={6} className="ps-0 other-text-field">
                      <TextField
                        id="outlined-basic"
                        label="Attractions Descriptions"
                        name="attractionsDescriptions"
                        variant="outlined"
                        defaultValue={
                          props && props.updatedFilterObj !== null && Object.keys(props.updatedFilterObj).find(key => key.toLowerCase() === "attractionsDescriptions") &&  props.updatedFilterObj[Object.keys(props.updatedFilterObj).find(key => key.toLowerCase() === "attractionsDescriptions")] !== null ?  props.updatedFilterObj[Object.keys(props.updatedFilterObj).find(key => key.toLowerCase() === "attractionsDescriptions")] :""
                        }
                        value={filters?.attractionsdescriptions||""}
                        onChange={handleChange(
                          "Attractions Descriptions",
                          "attractionsDescriptions"
                        )}
                        fullWidth
                        onKeyDown={handleEnter}
                      />
                      {ErrMsgAttractionsDescriptions !== "" ? (
                        <p className="error-msg text-field-error">
                          {ErrMsgAttractionsDescriptions &&
                            ErrMsgAttractionsDescriptions}
                        </p>
                      ) : (
                        ""
                      )}
                    </Col>
                  </Row>
                </div>
              </div>
              {/* <div className="amenities-btns">
                <Button
                  variant="outlined"
                  onClick={() => handleCancel()}
                  className="cancel-btn"
                >
                  Cancel
                </Button>
                <Button
                  variant="outlined"
                  onClick={() => onSubmit("1")}
                  className="submit-btn"
                  disabled={filters === null ? true : false}
                >
                  Submit
                </Button>
                <div className="clear"></div>
              </div> */}
            </TabPane>
            <TabPane tabId="3">
              <Row className="ms-0 tab-three-margin tab-section-three">
                <Col md={6} className="ps-0">
                  <FormControlLabel
                    control={
                      <Checkbox
                        defaultChecked={
                          props && props.updatedFilterObj !== null && Object.keys(props.updatedFilterObj).find(key => key.toLowerCase() === "hasOwner".toLowerCase()) &&  props.updatedFilterObj[Object.keys(props.updatedFilterObj).find(key => key.toLowerCase() === "hasOwner".toLowerCase())] !== null ?  props.updatedFilterObj[Object.keys(props.updatedFilterObj).find(key => key.toLowerCase() === "hasOwner".toLowerCase())] : false
                        }
                        onChange={handleChange("Ownership Info", "hasOwner")}
                        value="hasOwner"
                      />
                    }
                    label="Has OwnerShip Info"
                  />
                </Col>
                <Col md={6} className="ps-0">
                  <FormControlLabel
                    control={
                      <Checkbox
                        defaultChecked={
                          props && props.updatedFilterObj !== null && Object.keys(props.updatedFilterObj).find(key => key.toLowerCase() === "hasManagement".toLowerCase()) &&  props.updatedFilterObj[Object.keys(props.updatedFilterObj).find(key => key.toLowerCase() === "hasManagement".toLowerCase())] !== null ?  props.updatedFilterObj[Object.keys(props.updatedFilterObj).find(key => key.toLowerCase() === "hasManagement".toLowerCase())] : false
                        }
                        onChange={handleChange("Management Info", "hasManagement")}
                        value="hasManagement"
                      />
                    }
                    label="Has Management Info"
                  />
                </Col>
              </Row>
            </TabPane>
            <TabPane tabId="4">
              <div className="amenities-scroll">
                <Table className="amenities-table">
                  <thead>
                    <tr>
                      <th className="amenities-label"></th>
                      <th>Available</th>
                      <th>Not Available</th>
                    </tr>
                  </thead>
                  <TableBody>
                    <tr>
                    <td colSpan={4} className="amenities-label">
                      <FormLabel id="demo-radio-buttons-group-label">
                        <div className="img-text">
                          <span className="img-tag"><img src={ElectricHookup} alt="icons" className="table-icons"/></span>
                          <span className="pro-name">Electric Hookup</span>
                      </div>
                      </FormLabel>
                    </td>
                    </tr>
                    
                  {generateHookupsToggleItems()}
                  </TableBody>
                
                </Table>
              </div>
            </TabPane>
            <TabPane tabId="5" className="activity-items-list">

              <div style={{width:'100%'}}>
                <ReactSelect
                  isMulti
                  options={activityItems}
                  value={activityItems?.filter((item)=>selected.includes(item?.value))||[]}
                  onChange={handleChangeMultiSelect} 
                />
              </div>
            </TabPane>
             <TabPane tabId="6" className="activity-items-list">
              <div style={{width:'60%'}}>
              <Slider
                getAriaLabel={() => 'Stores in market'}
                value={[spotsInMarket.min||ConstantData.spotsInMarket.min,(spotsInMarket.max!==false&&spotsInMarket.max!==null)?spotsInMarket.max:ConstantData.spotsInMarket.max]}
                onChange={handleChangeMarketStores(null)}
                valueLabelDisplay="auto"
                getAriaValueText={getMinMaxValue}
                min={ConstantData.spotsInMarket.min}
                max={ConstantData.spotsInMarket.max}
                sx={{
                color: '#97cb5f',
                height: 4,       
                '& .MuiSlider-track': {
                  border: 'none',
                },
                '& .MuiSlider-thumb': {
                  height: 15,
                  width: 15,
                  backgroundColor: '#97cb5f',
                  '&:hover': {
                    boxShadow: '0 0 0 8px rgba(25, 118, 210, 0.16)',
                  },
                },
                '& .MuiSlider-rail': {
                  opacity: 0.28,
                  backgroundColor: '#97cb5f',
                },              
                width: '100%' 
              }}
               />            
             <Row>             
               <Col md={6} className="city-col">
                  <TextField                  
                    id="outlined-basic"
                    label="Min Spots"                    
                    variant="outlined"
                    name="minspots"  
                    type="number"
                    value={spotsInMarket.min=== false ? ConstantData.spotsInMarket.min :spotsInMarket.min }                    
                    onChange={handleChangeMarketStores(0) }
                    InputProps={numberInputProps}
                  />
                  {spotsError.min !== "" ? (
                    <p className="error-msg text-field-error">
                      {spotsError.min && spotsError.min}
                    </p>):""}
                </Col>
               <Col md={6} className="city-col">
                  <TextField
                    id="outlined-basic"
                    label={'Max Spots'} 
                    variant="outlined"
                    name="maxspots"
                    value={spotsInMarket.max=== false ? ConstantData.spotsInMarket.max :spotsInMarket.max }                   
                    onChange={handleChangeMarketStores(1)}
                    InputProps={numberInputProps}
                    fullWidth
                  />
                  {spotsError.max !== "" ? (
                    <p className="error-msg text-field-error">
                      {spotsError.max && spotsError.max}
                    </p>):""}
                </Col>
              </Row>  </div>
            </TabPane>

            <div className="amenities-btns">
              {filterResponse ? (
                <p className="error-msg">No RV Parks Found</p>
              ) : (
                ""
              )}
              <Button
                variant="outlined"
                onClick={() => handleCancel()}
                className="cancel-btn"
              >
                Cancel
              </Button>
              <LoadingButton
                onClick={() => !Object.values(spotsError).some(Boolean)&& onSubmit("1")}
                loading={refresh}
                variant="outlined"
                className="submit-btn"
              >
                Submit
              </LoadingButton>
              <div className="clear"></div>
            </div>
          </TabContent>
        </div>
      ) : (
        ""
      )}
    </div>
  );
});
